import { Transaction } from "@local-types/transaction/tableRow";
import { API_BASE_URL } from "./config";

export const fetchTransactions = async (): Promise<Transaction[]> => {
  const response = await fetch(`${API_BASE_URL}/transactions`);
  if (!response.ok) {
    throw new Error("Ошибка загрузки транзакций");
  }
  return response.json();
};

export const createTransaction = async (
  transaction: Omit<Transaction, "id">,
): Promise<Transaction> => {
  const response = await fetch(`${API_BASE_URL}/transactions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(transaction),
  });

  if (!response.ok) {
    throw new Error("Ошибка создания транзакции");
  }

  return response.json();
};

export const deleteTransaction = async (id: number): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/transactions/${id}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Ошибка удаления транзакции");
  }
};

export const updateTransaction = async (
  id: number,
  updates: Partial<Transaction>,
): Promise<Transaction> => {
  const response = await fetch(`${API_BASE_URL}/transactions/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error("Ошибка обновления транзакции");
  }

  return response.json();
};
